var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "transfer-right-body",
      attrs: {
        id: "remoteTask",
        "element-loading-background": "rgba(0, 0, 0, 0.05)"
      }
    },
    [
      _c("div", { staticClass: "task-top" }, [
        _c("div", { staticClass: "task-top-position" }, [
          _c("div", { staticClass: "transfer-name" }, [
            _vm._v(_vm._s(_vm.$t("language.common.btLink")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "transfer-description" }, [
            _vm._v(_vm._s(_vm.$t("language.remoteTask.createDescribe")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-middle" }, [
        _c("div", { staticClass: "task-box-position" }, [
          _c(
            "div",
            { staticClass: "task-box", class: _vm.boxFrom },
            [
              _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                _vm.sourceItems.length < 1
                  ? _c("div", { staticClass: "task-operating" }, [
                      _c("div", { staticClass: "task-operating-name" }, [
                        _vm._v(_vm._s(_vm.$t("language.cloudTransfer.from")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "box-center-btn",
                          on: {
                            click: function($event) {
                              return _vm.linkTaskOpen()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "icon-18-link" }),
                          _vm._v(
                            _vm._s(_vm.$t("language.remoteTask.addLink")) +
                              "\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "box-center-btn",
                          on: {
                            click: function($event) {
                              return _vm.addTorrent()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "icon-18-upload" }),
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.popup.remoteTaskPopup.addTorrent"
                              )
                            ) + "\n                            "
                          ),
                          _c("input", {
                            attrs: {
                              type: "file",
                              hidden: "hidden",
                              id: "torrent",
                              accept: ".torrent"
                            },
                            on: {
                              change: function($event) {
                                return _vm.torrentShow()
                              }
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.sourceItems.length == 1
                  ? _c("div", { staticClass: "task-main" }, [
                      _c("div", {
                        staticClass: "icon-del",
                        staticStyle: {
                          top: "-40%",
                          right: "-8%",
                          position: "absolute"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.removeItem(0)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "task-type large-file-type",
                        class:
                          "large-" + _vm.matchfileType(_vm.sourceItems[0].name)
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "task-catalog",
                          attrs: { title: _vm.sourceItems[0].name }
                        },
                        [_vm._v(_vm._s(_vm.sourceItems[0].name))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.sourceItems.length > 1
                  ? _c(
                      "div",
                      { staticClass: "task-source-more" },
                      [
                        _c("div", { staticClass: "task-source-title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("language.common.name")) +
                              "\n                            "
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "delete-btn",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.removeAll()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "icon-util delete" }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("language.cloudExploer.deleteAll")
                                  ) +
                                  "\n                            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.sourceItems, function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "source-item" },
                            [
                              _c("div", {
                                staticClass: "item-formicon small-file",
                                class: _vm.matchfileType(item.name) + "-small"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "item-url",
                                  attrs: { title: item.name }
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "icon-util round-cancel round-cancel-position",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.removeItem(index)
                                  }
                                }
                              })
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "task-box",
              class: _vm.boxTo,
              on: {
                click: function($event) {
                  return _vm.selectCloudOpen()
                }
              }
            },
            [
              !_vm.singleDrives
                ? _c("div", { staticClass: "task-operating" }, [
                    _c("div", { staticClass: "task-operating-name" }, [
                      _vm._v(_vm._s(_vm.$t("language.cloudTransfer.to")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-operating-des" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.cloudTransfer.transferOperateTo")
                        )
                      )
                    ])
                  ])
                : _c("div", { staticClass: "task-main" }, [
                    _c("div", {
                      staticClass: "task-type task-icon",
                      class: _vm.singleDrives.cloudType + "_big"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "task-catalog",
                        attrs: { title: _vm.singleDrives.cloudCatalog }
                      },
                      [_vm._v(_vm._s(_vm.singleDrives.cloudCatalog))]
                    )
                  ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "definite-operating" }, [
          _c(
            "div",
            { staticStyle: { position: "relative", "margin-left": "-2.3%" } },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.btnLoading,
                      expression: "btnLoading"
                    }
                  ],
                  staticClass: "transfer-button",
                  on: {
                    click: function($event) {
                      return _vm.transferNow()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon transfer-icon-position linkTask"
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { float: "left" } }, [
                    _vm._v(_vm._s(_vm.$t("language.remoteTask.nowUpload")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "flow" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.flowShow,
                        expression: "flowShow"
                      }
                    ],
                    staticClass: "flow-icon",
                    attrs: { id: "remoteFlow" }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "icon transfer-icon-position linkTask flow-icon-position"
                    })
                  ]
                )
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-buttom" }),
      _vm._v(" "),
      _c("parseTipsDialog", { ref: "parseTipsDialog" }),
      _vm._v(" "),
      _c("linkTaskDialog", { ref: "linkTaskDialog" }),
      _vm._v(" "),
      _c("subfileSelectDialog", { ref: "subfileSelectDialog" }),
      _vm._v(" "),
      _c("addEmialNoticeDialog", { ref: "addEmialNoticeDialog" }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" }),
      _vm._v(" "),
      _c("uploadToTreeDialog", { ref: "uploadToTreeDialog" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "task-box-middle" }, [
      _c("div", { staticClass: "arrow-position" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7139ad84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7139ad84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/remote_task.vue
// module id = null
// module chunks = 